import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./popupPage.css";

import {
    fetchBackupFileList,
    downloadBackup,
    uploadBackup
} from "../../services/backupService";


const TenantBackupsPopupForm = ({
  onClose
}) => {

    const [backups, setBackups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [progressMsg, setProgressMsg] = useState('');
    const [formData, setFormData] = useState({file: null});        


    useEffect(() => {
        async function load() {
            try {
                const data = await fetchBackupFileList();
                setBackups(data);
            } catch (error) {
                setError("Failed to load backups.");
                console.error(
                    "Failed to load backups:",
                    error
                );
            } finally {
                setLoading(false);
            }
        }
        load();

    }, []);

    async function handleDownload(filename) {
        try {
            const blob = await downloadBackup(filename);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
            alert("Backup download failed");
        }
    }

    // Handle file selection
    const handleFileChange = (e) => {
        const file = e.target.files[0];

        setFormData(prev => ({
            ...prev,
            file: file
        }));
    };

    /**
     * Handles the form submission, triggering the firmware update process.
     * @param {Event} e - The form submission event.
     */
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
          const result = await uploadBackup(formData.file);
          setProgressMsg("Backup uploaded successfully. Restore process initiated.");
          setError("");
          console.log("Backup uploaded:", result);
      } catch (err) {
          setProgressMsg("");
          setError(`Backup upload failed: ${err.message}`);
          console.error("Upload failed:", err);
      }
    };

    const formatSize = (bytes) => {
        if (!bytes) return "0 B";

        const units = ["B", "KB", "MB", "GB", "TB"];
        const index = Math.floor(Math.log(bytes) / Math.log(1024));

        return `${Number.parseFloat((bytes / 1024 ** index).toFixed(2))} ${units[index]}`;
    };


    if (loading) {
        return <div>Loading backups...</div>;
    }

    return (
        <div className="popup-overlay">
            <div className="popup">
                <div className="popup-header">
                    <span className="popup-title">Backup Mangement</span>
                    <button className="close-btn" onClick={onClose}><FontAwesomeIcon icon={faXmark} /></button>
                </div>
                  {error && <p className="error">{error}</p>}
                  {progressMsg && (
                      <div>
                          <p className = "success-message">{progressMsg}</p>
                      </div>
                  )}
                  {/* Backup avaliable List */}
                  <div className="backup-list">
                      <table>
                          <thead>
                              <tr>
                                  <th className="optional-column">Backup Date</th>
                                  <th className="optional-column">File Size</th>
                                  <th className="optional-column"></th>
                                  <th></th>
                              </tr>
                          </thead>
                      {backups?.length > 0 ? (
                          <tbody>
                              {backups.map((backup) => (
                                  <tr key={backup.filename}>
                                      <td>
                                          <span className="optional-column">
                                            {backup.date}
                                          </span>
                                      </td>
                                      <td>
                                          <span className="optional-column">
                                              {formatSize(backup.size)}
                                          </span>
                                      </td>
                                      <td>
                                        <span className="table-text">
                                            <button
                                            onClick={() => handleDownload(backup.filename)}
                                            className="submit-btn"
                                            >
                                            Download
                                            </button>
                                        </span>
                                      </td>
                                    </tr>
                              ))}
                          </tbody>
                          ):(
                            <tbody>
                              <tr>
                                <td colSpan="3" style={{ textAlign: 'center' }}>No backup fetched. Plesae login the session and try again</td>
                              </tr>
                            </tbody>
                          )  
                        }
                      </table>
                  </div>
                  <div className="popup-header">
                      <span className="popup-title">Upload Backups Files</span>
                  </div>
                  <div>
                    <form onSubmit={handleSubmit}>
                        <label className='file-label'>
                            {formData.file ? formData.file.name : "Choose File:"}
                            <input type="file" onChange={handleFileChange} required className="file-input"/>
                        </label>
                        {/* Buttons */}
                        <button class="popup-submit-btn" type="submit">
                          Restore
                        </button>
                    </form>
                  </div>                    
            </div>
        </div>
    );
}

TenantBackupsPopupForm.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default TenantBackupsPopupForm;